import { createSlice } from "@reduxjs/toolkit";
import {getInspections} from '../reduxApi/InspectionReduxApi'

const inspectionSlice = createSlice({
    name: 'inspection',
    initialState: {
        status: 'idel',
        inspection: [],
    },
    reducers: {
        deleteInspectionAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.inspection.findIndex((item) => item.inspections.ROWID === id);
                if (index !== -1) {
                    state.inspection.splice(index, 1);
                }
            });
        },
        updateInspectionAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.inspection.findIndex((item) => item.inspections.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.inspection.splice(index, 1, { inspections: action.payload })
            }
        },
        addInspectionAction: (state, action) => {
            console.log("Adding inspection:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.inspection.unshift({inspections:temp});
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInspections.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInspections.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing inspection Data", action.payload)
                state.inspection = action.payload.data.response
;
            })
    }
})
export const { deleteInspectionAction, updateInspectionAction, addInspectionAction } = inspectionSlice.actions
export default inspectionSlice.reducer